import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { Util } from '../../common/util/util';

export const fetchMainCatalog = createAsyncThunk(
  'mainCatalog/fetchAll',
  async (_, thunkApi) => {
    try {
      const dataResponce = await axios({
        method: 'get',
        baseURL: process.env.REACT_APP_BASE_URL_API,
        url: 'api/main-catalog',
        headers: {
          token: Util.getTokenSecurity(),
        },
      });

      return thunkApi.fulfillWithValue(dataResponce.data.catalog);
    } catch (error) {
      if (error instanceof Error) {
        return thunkApi.rejectWithValue(error.message);
      } else {
        return thunkApi.rejectWithValue('Loading Error');
      }
    }
  }
);

export const fetchArticles = createAsyncThunk(
  'articles/fetchAll',
  async (_, thunkApi) => {
    try {
      const dataResponce = await axios({
        method: 'get',
        baseURL: process.env.REACT_APP_BASE_URL_API,
        url: 'api/articles',
        headers: {
          token: Util.getTokenSecurity(),
        },
        params: {
          limit: 6,
          offset: 0,
        },
      });

      return thunkApi.fulfillWithValue(dataResponce.data.articles);
    } catch (error) {
      if (error instanceof Error) {
        return thunkApi.rejectWithValue(error.message);
      } else {
        return thunkApi.rejectWithValue('Loading Error');
      }
    }
  }
);

export const fetchServices = createAsyncThunk(
  'services/fetchAll',
  async (_, thunkApi) => {
    try {
      const dataResponce = await axios({
        method: 'get',
        baseURL: process.env.REACT_APP_BASE_URL_API,
        url: 'api/service-catalog',
        headers: {
          token: Util.getTokenSecurity(),
        },
      });

      return thunkApi.fulfillWithValue(dataResponce.data.services);
    } catch (error) {
      if (error instanceof Error) {
        return thunkApi.rejectWithValue(error.message);
      } else {
        return thunkApi.rejectWithValue('Loading Error');
      }
    }
  }
);
